import React from 'react';
import { Users } from 'lucide-react';
import type { OpsKaizenData } from './useOpsKaizenData';
import { CARD_TITLE_CLASS, KAIZEN_STRETCH_PANEL, PANEL_HEADER_COMPACT, formatPercent } from './opsKaizenShared';

interface OpsKaizenTeamTasksPanelProps {
  data: OpsKaizenData;
}

export const OpsKaizenTeamTasksPanel: React.FC<OpsKaizenTeamTasksPanelProps> = ({ data }) => (
  <div className={KAIZEN_STRETCH_PANEL}>
    <div className={PANEL_HEADER_COMPACT}>
      <div className="flex items-center gap-1.5">
        <Users size={13} className="text-sky-600" strokeWidth={2.25} />
        <span className={CARD_TITLE_CLASS}>Tarefas da Equipe</span>
      </div>
      <span className="text-[9px] font-medium uppercase tracking-wider text-[var(--text-muted)]">SLA 7d</span>
    </div>

    <div className="grid shrink-0 grid-cols-3 gap-1 border-b border-[var(--border-default)]/50 px-3 py-1">
      {[
        { label: 'Pendentes', value: data.teamPendingCount },
        { label: 'Em execução', value: data.teamInProgressCount },
        { label: 'Atrasadas', value: data.teamOverdueCount },
      ].map((item) => (
        <div key={item.label} className="rounded-sm border border-[var(--border-default)]/60 bg-[var(--bg-elevated)]/40 px-1.5 py-1 text-center">
          <div className="text-[8px] font-semibold uppercase tracking-wider text-[var(--text-muted)]">{item.label}</div>
          <div className="mt-0.5 text-[13px] font-semibold tabular-nums text-[var(--text-primary)]">{item.value}</div>
        </div>
      ))}
    </div>

    <div className="relative min-h-0 flex-1 overflow-hidden px-3 py-0.5">
      <table className="w-full border-collapse text-[10px]">
        <thead>
          <tr className="border-b border-[var(--border-default)]/60">
            <th className="px-1 py-0.5 text-left font-medium text-[var(--text-muted)]">Responsável</th>
            <th className="px-1 py-0.5 text-center font-medium text-[var(--text-muted)]">WIP</th>
            <th className="px-1 py-0.5 text-center font-medium text-[var(--text-muted)]">SLA</th>
          </tr>
        </thead>
        <tbody>
          {(data.hasUsersPerformance ? data.usersPerformance.slice(0, 4) : [{ user_id: '—', user_email: '—', avg_wip: 0, sla_rate_7d: 0 }]).map((userPerf) => (
            <tr key={userPerf.user_id} className="border-b border-[var(--border-default)]/40">
              <td className="max-w-[90px] truncate px-1 py-0.5 text-[var(--text-primary)]">{userPerf.user_email.split('@')[0]}</td>
              <td className="px-1 py-0.5 text-center font-semibold tabular-nums">{userPerf.avg_wip}</td>
              <td className="px-1 py-0.5 text-center tabular-nums">{formatPercent(userPerf.sla_rate_7d)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {!data.hasUsersPerformance && (
        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center bg-[var(--bg-surface)]/50">
          <span className="text-[10px] font-medium text-[var(--text-muted)]">Sem carga distribuída</span>
        </div>
      )}
    </div>
  </div>
);

export default OpsKaizenTeamTasksPanel;
